module.exports = __webpack_public_path__ + "img/card01.8b0f5e52.png";